// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_bambu_led_socket/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_bambu_led_socket: ModuleSchema = {
  "id": "core_bambu_led_socket",
  "uniqueId": "B3D_9BJZZ",
  "createdAt": "2026-10-02T05:13:16.061Z",
  "updatedAt": "2026-10-28T14:58:30.932Z",
  "label": "Bambu LED Socket",
  "description": "Template starting structure for creating new 3D parametric modules",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_SOCKET"
  ],
  "sliders": [
    {
      "key": "innerDia",
      "label": "Cavity Inner Diameter (for Ø60 LED Puck)",
      "min": 58,
      "max": 65,
      "default": 61,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "wallH",
      "label": "Cavity Wall Height",
      "min": 6,
      "max": 14,
      "default": 8,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "threadOuterDia",
      "label": "External Thread Diameter (M65 for Cap)",
      "min": 63,
      "max": 72,
      "default": 65,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "floorThick",
      "label": "Bottom Floor Thickness",
      "min": 1,
      "max": 3,
      "default": 1.5,
      "step": 0.25,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "centerHoleDia",
      "label": "Center Hole Diameter",
      "min": 30,
      "max": 54,
      "default": 48,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "wireSlotWidth",
      "label": "Cable Exit Slot Width",
      "min": 4,
      "max": 12,
      "default": 7,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "wireSlotH",
      "label": "Cable Exit Slot Height",
      "min": 2,
      "max": 7,
      "default": 4.5,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "flangeDia",
      "label": "Mounting Flange (65=Flush Cup, 75=Flange)",
      "min": 65,
      "max": 85,
      "default": 65,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "led_socket",
      "label": "Bambu LED Socket Cup",
      "default": "#7C2D12",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "socket_obj",
      "label": "Bambu LED Socket Cup",
      "name": "Bambu LED Socket Cup",
      "color": "#7C2D12",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "led_socket",
          "label": "Bambu LED Socket Cup",
          "name": "Bambu LED Socket Cup",
          "groupId": 0,
          "colorKey": "led_socket",
          "defaultColor": "#7C2D12",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Full LED Socket Cup",
      "groupId": -1
    }
  ]
};
